import React from 'react';
import { Image, ImageProps, ImageStyle } from 'react-native';

import { useAspectRatio } from '../../hooks/use-aspect-ratio';

interface OEImageProps extends ImageProps {
  ratio: string | number;
  width: number;
}

export const OEImage = ({ ratio, style, ...props }: OEImageProps) => {
  const { sizeStyle, onAspectRatioLayout } = useAspectRatio({
    width: props.width ?? '100%',
    ratio,
  });

  return (
    <Image
      onLayout={onAspectRatioLayout}
      resizeMode="cover"
      style={[style, sizeStyle as ImageStyle]}
      {...props}
    />
  );
};
